import * as React from 'react';
import './HomeButtonView.scss';
import { Props } from 'react';
import i18next from 'i18next';

interface HomeButtonViewProps extends Props<HomeButtonView> {
    clickHome: () => any;
    clickBack?: () => any;
    back?: boolean;
    elem?: any;
    fixed?: boolean;
    home?: boolean;
}

export class HomeButtonView extends React.Component<HomeButtonViewProps> {
    render() {
        const { clickHome, clickBack, back, elem, fixed, home } = this.props;
        const iconHome: any = require('../../../assets/icon_home.svg');
        const iconBack: any = require('../../../assets/icon-back.svg');
        return (
            <div className='button-container' style={{position: fixed ? 'fixed' : 'relative'}}>
                {!home ? <button className='home-button' onClick={clickHome}>
                    {i18next.t('to_services')}
                    <img src={iconHome} />
                </button> : ''}
                {elem ? elem : ''}
                {back && <button className='back-button' onClick={clickBack}>
                    <img src={iconBack} />
                    {i18next.t('back')}
                </button>}
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./src/components/Buttons/HomeButton/HomeButtonView.tsx